import CitySEOHead from "@/components/feature/CitySEOHead";
import BrokenArrowHeroSection from "./components/HeroSection";
import BrokenArrowStickyNav from "./components/StickyNav";
import BrokenArrowProcessingTimeSection from "./components/ProcessingTimeSection";
import BrokenArrowServicesSection from "./components/ServicesSection";
import BrokenArrowLocalAreaSection from "./components/LocalAreaSection";
import BrokenArrowTravelTimingSection from "./components/TravelTimingSection";
import BrokenArrowDestinationsSection from "./components/DestinationsSection";
import BrokenArrowTestimonialsSection from "./components/TestimonialsSection";
import BrokenArrowAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import BrokenArrowComparisonSection from "./components/ComparisonSection";
import BrokenArrowMistakesSection from "./components/MistakesSection";
import BrokenArrowHowItWorksSection from "./components/HowItWorksSection";
import BrokenArrowFAQSection, { faqs } from "./components/FAQSection";
import BrokenArrowHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import BrokenArrowFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const pageTitle = "Emergency Passport Broken Arrow, OK — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Broken Arrow, OK — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Broken Arrow families, church mission groups, NSU-BA students, and Tulsa east metro professionals.";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for Broken Arrow travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens in Broken Arrow with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance for Broken Arrow residents with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Mission Trip Group Processing", description: "Group passport coordination for Broken Arrow church mission trips to Guatemala, Honduras, Costa Rica, and beyond." },
];

export default function BrokenArrowPage() {
  return (
    <>
      <CitySEOHead
        city="Broken Arrow"
        state="Oklahoma"
        stateAbbr="OK"
        route="/cities/broken-arrow"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Broken Arrow, Oklahoma"
        geoPosition="36.0526;-95.7975"
        keywords="expedited passport Broken Arrow, emergency passport Broken Arrow OK, same day passport Broken Arrow, fast passport Oklahoma, passport renewal Broken Arrow, Tulsa metro passport, mission trip passport"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Oklahoma"
        statePageRoute="/states/oklahoma"
        lastModified="2026-06-09"
        serviceAreaDesc="Fast Passport Center does not have a physical office in Broken Arrow — we serve this area remotely. Emergency and expedited passport services as fast as 24 hours for Broken Arrow and Tulsa east metro travelers."
      />

      <div className="font-sans">
      <BrokenArrowHeroSection />
      <BrokenArrowStickyNav />
      <BrokenArrowProcessingTimeSection />
      <BrokenArrowServicesSection />
      <BrokenArrowLocalAreaSection />
      <BrokenArrowTravelTimingSection />
      <BrokenArrowDestinationsSection />
      <BrokenArrowTestimonialsSection />
      <BrokenArrowAcceptanceFacilitiesSection />
      <BrokenArrowComparisonSection />
      <BrokenArrowMistakesSection />
      <BrokenArrowHowItWorksSection />
      <BrokenArrowFAQSection />
      <BrokenArrowHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/broken-arrow" state="OK" />
      <BrokenArrowFinalCTA />
      </div>
    </>
  );
}